export const setCookie = (name, value, options = {}) => {
  let cookieString = `${name}=${value}`;

  if (options.path) {
    cookieString += `; path=${options.path}`;
  }

  if (options.maxAge) {
    cookieString += `; max-age=${options.maxAge}`;
  }

  if (options.domain) {
    cookieString += `; domain=${options.domain}`;
  }

  if (options.secure) {
    cookieString += `; secure`;
  }

  if (options.sameSite) {
    cookieString += `; samesite=${options.sameSite}`;
  }

  if (options.expires) {
    cookieString += `; expires=${options.expires}`;
  }

  document.cookie = cookieString;
};